export default __webpack_public_path__ + "static/media/reims10.5c718e8c.jpg";